import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { FiCalendar } from "react-icons/fi";
import "react-datepicker/dist/react-datepicker.css";

export default function AddLeaveModal({ show, handleClose, onAddLeave }) {
  const [leaveType, setLeaveType] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [session, setSession] = useState("");
  const [days, setDays] = useState("");
  const [reason, setReason] = useState("");

  const resetForm = () => {
    setLeaveType("");
    setFromDate(null);
    setToDate(null);
    setSession("");
    setDays("");
    setReason("");
  };

  useEffect(() => {
    if (!show) {
      resetForm();
    }
  }, [show]);

  const handleAddLeaveClick = () => {
    if (!leaveType || !fromDate || !toDate || !session || !days) {
      alert("Please fill all required fields");
      return;
    }

    const newLeave = {
      type: leaveType,
      from: fromDate.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }),
      to: toDate.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }),
      session: session,
      days: `${days} Days`,
      reason: reason,
      name: "Current User",
      role: "Employee",
      avatar: "/assets/img/users/user-34.jpg",
    };

    onAddLeave(newLeave);
    resetForm();
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="lg"
        backdrop="static"
      >
        {/* HEADER */}
        <Modal.Header closeButton>
          <Modal.Title>Add Leave</Modal.Title>
        </Modal.Header>

        {/* BODY */}
        <Modal.Body>
          <Form>
            {/* Leave Type */}
            <Form.Group className="mb-3">
              <Form.Label>Leave Type</Form.Label>

              <Form.Select
                className="custom-input"
                value={leaveType}
                onChange={(e) => setLeaveType(e.target.value)}
              >
                <option value="">Select</option>
                <option value="Medical Leave">Medical Leave</option>
                <option value="Casual Leave">Casual Leave</option>
                <option value="Annual Leave">Annual Leave</option>
              </Form.Select>
            </Form.Group>

            {/* FROM / TO */}
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>From</Form.Label>

                  <div className="date-input-wrapper">
                    <DatePicker
                      selected={fromDate}
                      onChange={(date) => setFromDate(date)}
                      dateFormat="dd-MM-yyyy"
                      placeholderText="dd/mm/yyyy"
                      className="form-control custom-input"
                    />

                    <FiCalendar className="calendar-icon" />
                  </div>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>To</Form.Label>

                  <div className="date-input-wrapper">
                    <DatePicker
                      selected={toDate}
                      onChange={(date) => setToDate(date)}
                      dateFormat="dd-MM-yyyy"
                      placeholderText="11-03-2026"
                      className="form-control custom-input"
                    />

                    <FiCalendar className="calendar-icon" />
                  </div>
                </Form.Group>
              </Col>
            </Row>
            {/* SESSION / REMAINING */}
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Session</Form.Label>

                  <Form.Select
                    className="custom-input"
                    value={session}
                    onChange={(e) => setSession(e.target.value)}
                  >
                    <option value="">Select</option>
                    <option value="First Half">First Half</option>
                    <option value="Second Half">Second Half</option>
                    <option value="Full Day">Full Day</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Remaining Days</Form.Label>

                  <Form.Control
                    type="text"
                    value="8"
                    readOnly
                    className="custom-input"
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* NO OF DAYS */}
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>No of Days</Form.Label>
                  <Form.Control
                    type="text"
                    className="custom-input"
                    value={days}
                    onChange={(e) => setDays(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* REASON */}
            <Form.Group>
              <Form.Label>Reason</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                className="custom-textarea"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>

        {/* FOOTER */}
        <Modal.Footer>
          <Button variant="light" onClick={handleClose}>
            Cancel
          </Button>

          <Button className="add-btn" onClick={handleAddLeaveClick}>
            Add Leave
          </Button>
        </Modal.Footer>
      </Modal>

      {/* CSS */}
      <style>
        {`

/* INPUT STYLE */

.custom-input{
height:44px;
border-radius:6px;
font-size:14px;
padding-right:40px;
}

/* TEXTAREA */

.custom-textarea{
border-radius:6px;
font-size:14px;
}

/* DATE INPUT WRAPPER */

.date-input-wrapper{
position:relative;
}

/* CALENDAR ICON */

.calendar-icon{
position:absolute;
right:140px;
// top:50%;
transform:translateY(-50%);
color:#6b7280;
pointer-events:none;
}

/* BUTTON */

.add-btn{
background:#f26522;
border:none;
padding:8px 22px;
}

.add-btn:hover{
background:#f26522;
}

/* DROPDOWN SELECTED COLOR */

select option:checked{
background:#f26522;
color:white;
}
.date-input-wrapper{
position: relative;
}

.custom-input{
height:44px;
padding-right:40px; /* space for icon */
border-radius:6px;
}

.calendar-icon{
position:absolute;
right:170px;
top:50%;
transform:translateY(-50%);
font-size:18px;
color:#6b7280;
pointer-events:none;
}
@media (max-width:991px){

.calendar-icon{
right:12px;
}

.custom-input{
padding-right:42px;
}

}

@media (max-width:576px){


.calendar-icon{
right:60px;
}


.date-input{
padding-right:40px;
}
}

`}
      </style>
    </>
  );
}
